export default __webpack_public_path__ + "6c138261aab59b31993415f8d089b272.svg";